const API_URL = process.env.REACT_APP_API_URL + "admin/";
const token = localStorage.getItem("token");

export const GetAllAdminsApi = async ({
  page = 1,
  limit = 10,
  filters = {}
}) => {

  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    const response = await fetch(`${API_URL}?${params.toString()}`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    

    return {
      status: 'success',
      data: responseData.data || [],
      page: parseInt(responseData.page) || 1,
      total: parseInt(responseData.total) || 0,
      totalPages: parseInt(responseData.totalPages) || 1,
      limit: parseInt(responseData.limit) || limit
    };
  } catch (error) {
    console.error("[GetAllReservationsApi] Error:", error);
    throw error;
  }
};

export const GetAdminById = async (id) => {
  let data = null;
  const response = await fetch(API_URL + id , {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${token}`
    },
  });

  if (response.ok) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};

export const UpdateAdmin = async (id, requestData) => {
  let data=null
  const response = await fetch(API_URL + id , {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(requestData)
  });

  if (response.ok) {
    data = await response.json();
  }

  return {
    data: data,
    status: response.status
  };
};
